module.exports = __webpack_public_path__ + "static/media/jamie-sparker-audition-tapes3.b798623c.png";